module.exports = __webpack_public_path__ + "static/media/PLAYER6.f79b7fb2.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Element/img/PLAYER6.png
// module id = 272
// module chunks = 0